import Model from "../classes/Model";
import ScheduleApi from "../classes/api/Schedule";
import ValidationError from "../classes/ValidationError";
import dateFormat from 'dateformat';
import Trainer from "./v2/Trainer";
import ScheduleReplace from "./v2/ScheduleReplace";

export default class Event extends Model {

    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get start() {
        if (!this._start) {
            return '';
        }
        return dateFormat((new Date()).setTime(this._start * 1000), 'yyyy-mm-dd HH:MM');
    }
    set start(value) {
        if (value instanceof Number) {
            this._start = value;
        }
        this._start = (new Date(dateFormat((new Date(value))))).getTime() / 1000;
    }
    get startTimestamp() {
        return this._start;
    }
    get end() {
        if (!this._end) {
            return '';
        }
        return dateFormat((new Date()).setTime(this._end * 1000), 'yyyy-mm-dd HH:MM');
    }
    set end(value) {
        if (value instanceof Number) {
            this._end = value;
        }
        this._end = (new Date(dateFormat((new Date(value))))).getTime() / 1000;
    }
    get endTimestamp() {
        return this._end;
    }
    get directionId() {
        return this._directionId;
    }
    set directionId(value) {
        this._directionId = value;
    }
    get filiationId() {
        return this._filiationId;
    }
    set filiationId(value) {
        this._filiationId = value;
    }
    get fitnessRoomId() {
        return this._fitnessRoomId;
    }
    set fitnessRoomId(value) {
        this._fitnessRoomId = value;
    }
    get trainerId() {
        return this._trainerId;
    }
    set trainerId(value) {
        this._trainerId = value;
    }
    get capacity() {
        return this._capacity;
    }
    get rented() {
        return this._rented;
    }
    set rented(value) {
        this._rented = value;
    }
    set capacity(value) {
        this._capacity = value;
    }
    get fill() {
        return this._fill;
    }
    set fill(value) {
        this._fill = value;
    }
    get updated() {
        return this._updated;
    }
    set updated(value) {
        this._updated = value;
    }
    get clients() {
        return this._clients;
    }
    set clients(value) {
        this._clients = value;
    }
    get visits() {
        return this._visits;
    }
    set visits(value) {
        this._visits = value;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[field] = config[field];
        }
    }



    toRequest() {
        const dateStart = new Date();
        dateStart.setTime(this.startTimestamp * 1000);
        const dateEnd = new Date();
        dateEnd.setTime(this.endTimestamp * 1000);
        return {
            id: this.id,
            date: dateFormat(dateStart, 'yyyy-mm-dd'),
            time_start: dateFormat(dateStart, 'HH:MM:ss'),
            time_end: dateFormat(dateEnd, 'HH:MM:ss'),
            direction_id: this.directionId,
            filiation_id: this.filiationId,
            fitness_room_id: this.fitnessRoomId,
            trainer_id: this.trainerId,
            capacity: this.capacity,
            fill: this.fill,
            clients: [],
        };
    }

    static toResponse(data) {
        let trainer = null;
        if (undefined !== data.trainer && data.trainer) {
            trainer = new Trainer(data.trainer);
        }
        let replace = null;
        if (undefined !== data.replace && data.replace) {
            replace = new ScheduleReplace(data.replace);
        }
        return {
            id: data.id,
            start: data.start * 1000,
            end: data.end * 1000,
            directionId: data.direction_id,
            filiationId: data.filiation_id,
            fitnessRoomId: data.fitness_room_id,
            trainerId: data.trainer_id,
            capacity: data.capacity,
            fill: data.fill,
            rented: data.rented,
            clients: [],
            trainer: trainer,
            replace: replace,
            updated: {
                login: data.updater_login,
                date: data.updated_date,
            },
        };
    }

    static getListByDay(filiationId, startDate, endDate = undefined) {
        return ScheduleApi.getDay(filiationId, startDate, endDate).then((response) => {
            let data = [];
            for (let event of response.data) {
                data.push(new this(this.toResponse(event)));
            }
            return data;
        });
    }

    static get(id) {
        return ScheduleApi.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }

    add() {
        let request = this.toRequest();
        return ScheduleApi.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            this.id = Number(data.id);
            this.fill = 0;
            this.updated = {};
            this.updated.login = data.creator_login;
            this.updated.date = data.created_date;
            return this;
        });
    }

    update(reasonId = false) {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();

        if (reasonId !== false) {
            request.reason_id = reasonId;
        }
        return ScheduleApi.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return data;
        })
    }

    remove() {
        return ScheduleApi.remove({id: this.id}).then(({data}) => {
            return data.success;
        });
    }

}
